import { makeObservable, observable } from 'mobx'

class LeaveStore {
  hoveredLeaveId: number | null | undefined

  constructor() {
    makeObservable(this, {
      hoveredLeaveId: observable,
    })
  }
}

export default LeaveStore
